/*
 * Built with Common Launchpad 2.0.3
 */

import $ from 'jquery';

function isValidEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

class NewsletterSignUp {
    constructor() {

    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        $('.form--newsletter-signup').on('submit', this.newsletterSubmit);
    }

    submitNewsletter(form) {
        let xhr = new XMLHttpRequest();

        xhr.open('POST', '/api/newsletter');
        xhr.send(form);
    }

    newsletterSubmit(event) {
        event.preventDefault();

        let form = event.target;
        let formData = new FormData(form);
        let email = formData.get('email');
        let postalCode = formData.get('zipcode');
        let valid = isValidEmail(email);
        if (postalCode !== '' && email !== '' && valid) {
            if (formData != null) {
                $('button[type=submit], input[type=submit]').prop('disabled', true);
                $.ajax({
                    processData: false,
                    contentType: 'application/json',
                    dataType: 'json',
                    method: 'post',
                    data: JSON.stringify({ model: { email, postalCode } }),
                    url: '/api/newsletter',
                    complete(e) {
                        $('.form-success').toggleClass('hidden');
                        $('.form--newsletter-signup').find('input[type=text]').val('');
                        $('button[type=submit], input[type=submit]').prop('disabled', false);
                        $('.newsletter-signup').addClass('hidden');
                    }
                });
            }
        }
    }
}

export default NewsletterSignUp;

$(() => {
    const newslettersignup = new NewsletterSignUp();
    newslettersignup.init();
});